import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatToolbarModule } from '@angular/material/toolbar'
import { FlexLayoutModule } from '@angular/flex-layout';
import { CandidateLoginComponent } from './candidate-login/candidate-login.component';
import { MatCardModule } from '@angular/material/card'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WelcomeComponent } from './welcome/welcome.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list'
import { MenuListItemComponent } from './menu-list-item/menu-list-item.component'
import { AuthHeaderInterceptor } from './http-interceptors/auth-header-interceptor';
import { CandidatePersonalDetailsComponent } from './candidate-personal-details/candidate-personal-details.component';
import { CandidateComponentDataEntryComponent } from './candidate-component-data-entry/candidate-component-data-entry.component';
import { MaterialFileInputModule } from 'ngx-material-file-input';
// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CandidateAuthorizationComponent } from './candidate-authorization/candidate-authorization.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AlreadySubmittedComponent } from './already-submitted/already-submitted.component';
import { CandidateDataEntryCompletionComponent } from './candidate-data-entry-completion/candidate-data-entry-completion.component'
import { RouterModule } from '@angular/router';
import {MatDialogModule} from '@angular/material/dialog';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import {MatStepperModule} from '@angular/material/stepper';
import { SidenavComponent } from './new-cde/sidenav/sidenav.component';
import { ComponentDataEntryComponent } from './new-cde/component-data-entry/component-data-entry.component';
import { PersonalDataEntryComponent } from './new-cde/personal-data-entry/personal-data-entry.component';
import { AuthorizationCompComponent } from './new-cde/authorization-comp/authorization-comp.component';
import { InstructionComponent } from './new-cde/instruction/instruction.component';

@NgModule({
  declarations: [
    AppComponent,
    CandidateLoginComponent,
    WelcomeComponent,
    MenuListItemComponent,
    CandidatePersonalDetailsComponent,
    CandidateComponentDataEntryComponent,
    CandidateAuthorizationComponent,
    AlreadySubmittedComponent,
    CandidateDataEntryCompletionComponent,
    SidenavComponent,
    ComponentDataEntryComponent,
    PersonalDataEntryComponent,
    AuthorizationCompComponent,
    InstructionComponent,
  ],

imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    FlexLayoutModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatListModule,
    MatGridListModule,
    MatMenuModule,
    MatSelectModule,
    MaterialFileInputModule,
    NgxExtendedPdfViewerModule,
    SignaturePadModule,
    MatCheckboxModule,
    MatDialogModule,
    MatStepperModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthHeaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
